import { Stack } from "expo-router";

export default function DogRunsLayout() {
  return (
    <Stack
      screenOptions={{
        headerStyle: { backgroundColor: "#ffffff" },
        headerTitleStyle: { fontWeight: "700", color: "#111827" },
        headerShadowVisible: false,
        headerBackTitle: "Back",
      }}
    >
      <Stack.Screen name="log-run" options={{ title: "Log a Run", headerShown: false }} />
      <Stack.Screen name="import-runs" options={{ title: "Import Runs", headerShown: false }} />
      <Stack.Screen name="edit" options={{ title: "Edit Dog", headerShown: false }} />
      <Stack.Screen name="import-screenshot" options={{ title: "Import from Screenshot", headerShown: false }} />
      <Stack.Screen name="card" options={{ title: "Dash-Hound Trading Card", headerShown: false }} />
    </Stack>
  );
}
